export default import.meta.ROLLDOWN_FILE_URL_rfS_nvSuw5jzARqapwRlEQ